const initialState = {};
export const SAVE_ROW_ERROR = 'SAVE_ROW_ERROR';
export const SAVE_CELL_ERRORS = 'SAVE_CELL_ERRORS';

export const saveRowError = (rowId, hasError) => {
    return {
        type: SAVE_ROW_ERROR,
        payload: { rowId, hasError },
    };
};

export const saveCellErrors = (rowId, cellErrors) => {
    return {
        type: SAVE_CELL_ERRORS,
        payload: { rowId, cellErrors },
    };
};

export const rowErrorsReducer = (state = initialState, action) => {
    switch (action.type) {
        case SAVE_ROW_ERROR:
            return {
                ...state,
                [action.payload.rowId]: {
                    ...state[action.payload.rowId],
                    hasError: action.payload.hasError
                },
            };
        case SAVE_CELL_ERRORS:
            return {
                ...state,
                [action.payload.rowId]: {
                    ...state[action.payload.rowId],
                    cellErrors: action.payload.cellErrors
                },
            };
        default:
            return state;
    }
};
